<template lang="html">
  <div>
    <div class="mng-model-scene-cad">
      <div class="box" v-show="sliderFlag" @click.stop="sliderFlag=false"></div>
      <div class="handle-left">
        <h4>
          <h5>
            <img src="../../../assets/views/models/eye.png" alt="">
            CAD图
          </h5>
          <div v-show="imagePreviewing">
            <em>不透明度</em>
            <span>
              {{sliderValue}}%
              <i class="triangle" @click="sliderFlag=true"></i>
              <div class="slider-wrapper" v-show="sliderFlag">
                <el-slider v-model="sliderValue" :show-tooltip="false" class="slider"
                           @change="sliderHandle(sliderValue)"></el-slider>
              </div>
            </span>
          </div>

        </h4>
        <div class="original">
          <p class="original-center upload-button" @click="onClick($event)">
            <img src="../../../assets/views/models/add-file.png" class="icon-add"
                 v-show="!imagePreviewing">
            <img v-show="imagePreviewing" :src="imagePreviewing" class="upload__image">
          </p>
          <img src="../../../assets/views/models/delete-cad.png" class="delete-cad"
               v-show="imagePreviewing" @click="deleteHandle">
        </div>
        <h4 class="look-down">
          <h5>
            <img src="../../../assets/views/models/eye.png" alt="">
            俯视图
          </h5>
        </h4>
        <div class="original">
          <p class="original-center">
          </p>
        </div>
        <p :class="[uploadSuccee?'save-button-succee':'save-button-disabled']" @click="download"
           ref="uploadButton">
          <img src="../../../assets/views/models/download-disabled.png" alt=""
               v-show="!uploadSuccee">
          <img src="../../../assets/views/models/download.png" alt="" v-show="uploadSuccee">
          保存并下载底图
        </p>
      </div>
      <div>
        <div id="actions">
          <div>
            <div id="buttondiv" v-show="false">
              <div id="buttonL">
                <input type="checkbox"
                       :checked="is_checked"
                       @click="(is_checked = !is_checked)">显示图片
                <el-button @click="onClick($event)">打开图片</el-button>
              </div>
              <div id="buttonR">
                <el-button @click="getPoint($event)">保存坐标</el-button>
              </div>
            </div>
            <div v-show="is_checked" id="cadimagediv">
              <img v-if="imagePreviewing" :src="imagePreviewing" class="upload__image"
                   ref="uploadImage">
            </div>
            <div id="cadimagedivBG">
            </div>
            <div id="drawboard">
              <canvas id="canvas"
                      width="1000"
                      height="1000">
              </canvas>
            </div>
          </div>
        </div>
        <div id="canvas3d"/>
      </div>
    </div>
    <input ref="uploader"
           type="file"
           class="upload__input"
           :accept="accept"
           @change="previewImage">
  </div>
</template>

<script>
  import axios from 'axios';
  import {
    Scene, Color, WebGLRenderer, AxisHelper, SpotLight,
    OrthographicCamera, CubeGeometry, Mesh, MeshBasicMaterial, Vector3
  } from 'three';

  import {OrbitControls} from '../../../controls/OrbitControls';
  import {GLTFLoader} from '../../../loaders/GLTFLoader';


  export default {
    props: {
      text: {type: String, default: '上传文件'},
      sub: {type: String, default: ''},
      accept: {type: String, default: 'image/*'},
      imageUrl: {type: String, default: null},
      width: {type: String, default: '100px'},
      height: {type: String, default: '100px'},
      size: {type: String, default: 'normal'}, /* eslint-disable */
      filesize: 0
    },
    data() {
      return {
        context: {}, // 2d context
        scene: {},  // 3d 场景
        loading: true,
        sceneData: [],  // 场景数据
        CANVAS_WIDTH: 1000, // 场景宽高
        CANVAS_HEIGHT: 1000,
        imagePreviewing: null,
        pointUVList: [],    // 映射点数据
        is_checked: true,
        cadSrc: '',
        cadWidth: '',
        cadHeight: '',
        uploadSuccee: false,
        sliderValue: 0, // 透明度滑块,
        sliderFlag: false, //  不透明度显示
        shotImageUrl: '',
        httpAxios: axios.create({}),
        cadImageUrl: '',
        centerX: '',
        centerY: '',
        storeName: '',
        scale: ''
      };
    },
    computed: {},
    mounted() {
      //初始化 3D 和 2D 画布
      this.canvas3d = document.querySelector('#canvas3d');
      this.onInitialized();
      const canvas = document.querySelector('#canvas');
      this.context = canvas.getContext('2d');
      this.getCurrentShot(150, 150, false);
      this.getStoreInfo();
    },
    methods: {
      onInitialized() {
        //  加载数据
        this.loadSceneData();
        //  初始化3D场景
        this.initMesh();
      },
      async loadSceneData() {
        // 加载数据
        this.loading = true;
        const {data: {data: sceneData}} = await this.$http.post(
          '/v1/list-panoramas?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {store_id: this.$route.params.modelId}
        );
        //  console.log(sceneData);
        this.scenePoint = sceneData.panorama_list.map((pano) => {
          const p = {coordinate: {}};
          p.coordinate.positionX = pano.coordinate.position_x;
          p.coordinate.positionY = pano.coordinate.position_y;
          p.coordinate.positionZ = pano.coordinate.position_z;
          p.coordinate.directionX = pano.coordinate.direction_x;
          p.coordinate.directionY = pano.coordinate.direction_y;
          p.coordinate.directionZ = pano.coordinate.direction_z;
          p.coordinate.directionW = pano.coordinate.direction_w;
          p.coordinate.panoramaId = pano.coordinate.panorama_id;
          p.coordinate.id = pano.coordinate.id;
          p.panoramaImages = pano.panorama_images;
          p.panoramaImagesLow = pano.panorama_images_low;
          p.sequenceId = pano.seq_id;
          p.visiblePanoramaSequenceIds = pano.visible_panorama_seq_ids;
          p.visible = pano.visible;
          p.id = pano.id;
          return p;
        });
        //  console.log(this.sceneData);
        this.loadModel(sceneData.modelPath);
      },
      initMesh() {
        // 初始化场景
        this.scene = new Scene(); // 场景
        this.scene.background = new Color(196, 196, 196);
        this.camera = new OrthographicCamera(-20, 20, 20, -20, 0.1, 1000);
        this.camera.position.y = 100;
        this.camera.lookAt(this.scene.position);
        this.renderer = new WebGLRenderer({antialias: true});// 渲染器
        this.renderer.setSize(this.CANVAS_WIDTH, this.CANVAS_WIDTH);
        const axes = new AxisHelper(20);// 坐标轴
        const spotLight = new SpotLight(0xffffff);
        spotLight.position.set(-40, 200, -10);
        spotLight.castShadow = true;
        this.scene.add(axes);// 场景添加坐标轴
        this.scene.add(spotLight);
        this.canvas3d.append(this.renderer.domElement);
        this.renderThisFrame = true;
        this.renderScene();
        this.mcontrols = new OrbitControls(this.camera, this.renderer.domElement);
        this.mcontrols.enablerotateUp = false;
        //  事件
        this.mcontrols.addEventListener('_render', () => {
          this.renderThisFrame = true;
        });
      },
      renderScene() {
        //  渲染3D场景
        if (this.renderThisFrame) {
          this.renderer.render(this.scene, this.camera);
        }
        this.renderThisFrame = false;
        requestAnimationFrame(this.renderScene);
      },
      loadModel(modelPath) {
        //  加载模型
        const gltfLoader = new GLTFLoader();
        gltfLoader.load(modelPath, (gltf) => {
          const object = gltf.scene;
          object.rotateX(-Math.PI / 2);
          object.updateWorldMatrix();
          this.model = object;
          this.scene.add(object);
          this.draw3DPotint();
          this.renderThisFrame = true;
          this.loading = false;
          object.children[0].geometry.computeBoundingBox();
          //  object.children[0].geometry.center()
          // console.log( object.children[0].geometry.boundingBox.max.x);
          // console.log(object.children[0].geometry.boundingBox.max.y);
          // console.log(object.children[0].geometry.boundingBox.max.z);
          this.mcontrols.panLeft2(-(object.children[0].geometry.boundingBox.max.x + object.children[0].geometry.boundingBox.min.x) / 2);
          this.mcontrols.panUp2((object.children[0].geometry.boundingBox.max.y + object.children[0].geometry.boundingBox.min.y) / 2);
          this.mcontrols.update();
          // const dy = 2.45/ 74.45;
          // const dy2 = 0.85 / 44;
          // let scale = 1;
          // if (object.children[0].geometry.boundingBox.max.y > 100) {
          //   scale = (object.children[0].geometry.boundingBox.max.y - 100) * dy;
          // } else {
          //   scale = 1;
          // }
          // this.mcontrols.setScale(scale);
          // const helper = new BoxHelper(object, 0xff0000);
          // helper.update();
          // this.scene.add(helper);
        });
      },
      draw3DPotint() {
        //  根据数据绘制3D全景点位
        this.scenePoint.forEach((element) => {
          const cube = new Mesh(
            new CubeGeometry(1, 1, 1, 1, 1, 1),
            new MeshBasicMaterial({color: 0xff0000, wireframe: true})
          );
          let orgposition = new Vector3(element.coordinate.positionX,
            element.coordinate.positionY, element.coordinate.positionZ);
          orgposition = orgposition.clone().applyAxisAngle(new Vector3(1, 0, 0), -Math.PI / 2);
          cube.position.x = orgposition.x;
          cube.position.y = orgposition.y;
          cube.position.z = orgposition.z;
          this.scene.add(cube);
          element.cube = cube;
        });
      },
      onClick() {
        this.$refs.uploader.click();
      },
      getCurrentShot(width, height, flag) {
        //  获取3D 当前截图
        // const shotimage = new Image(this.CANVAS_WIDTH,this.CANVAS_HEIGHT);
        const shotimage = new Image(width, height,);
        try {
          this.renderer.render(this.scene, this.camera);
          const imgData = this.renderer.domElement.toDataURL("image/jpeg");
          shotimage.src = imgData;
          this.shotImageUrl = imgData;
        } catch (e) {
          console.error(e);
        }
        if (flag) this.downloadIamge(shotimage.src);
        return shotimage;
      },
      downloadIamge(imgsrc, name) {//下载图片地址和图片名
        let image = new Image(1000, 1000);
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function () {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          let url = canvas.toDataURL("image/jpeg"); //得到图片的base64编码数据
          let a = document.createElement("a"); // 生成一个a元素
          let event = new MouseEvent("click"); // 创建一个单击事件
          a.download = name || "photo"; // 设置图片名称
          a.href = url; // 将生成的URL设置为a.href属性
          a.dispatchEvent(event); // 触发a的单击事件
        };
        image.src = imgsrc;
      },
      previewImage() {
        //  加载2D图
        const fileReader = new FileReader();
        fileReader.addEventListener('load', () => {
          this.imagePreviewing = fileReader.result;
          const thethis = this; /* eslint-disable */
          const image = new Image();
          image.src = fileReader.result;// eslint-disable-next-line
          this.cadSrc = fileReader.result;
          image.onload = function () {
            thethis.$emit('imagescale', this.width / this.height);
            thethis.cadHeight = this.height;
            thethis.cadWidth = this.width;
          }/* eslint-disable */
        }, false);
        const file = this.$refs.uploader.files[0];     /* eslint-disable */
        console.log('image.src:',file);
        if (file) {
          fileReader.readAsDataURL(file);
          this.$emit('filesize', file.size);
          this.uploadSuccee = true;
        }
        // else this.imagePreviewing = null;
      },
      async saveImage() {
        //  console.log('save image and point date!');
        const canvas = document.querySelector('#canvas');
        const image = canvas.toDataURL('image/jpeg');
        try {
          const {data} = await this.$http.post(
            '/admin/modify-store-floor-plan',
            {
              store_id: this.$route.params.modelId,
              floor_plan: image.replace(/data:image.*?,/gi, '')
            }
          );
          if (data.error_no === 200) {
            this.$message.basic({
              message: '添加成功'
            });
            this.closeDialog();
          } else {
            this.$log(data.error_msg);
          }
        } catch (error) {
          this.$log(error.error_msg || error);
        }
      },
      async savePointUV() {
        //  console.log('save image and point UV!');
        try {
          const {data} = await this.$http.post(
            '/admin/modify-store-uv-list',
            {
              store_id: this.$route.params.modelId,
              uv_list: this.pointUVList
            }
          );
          //  console.log(data);
          if (data.error_no === 200) {
            this.$message.basic({
              message: '添加UV成功'
            });
            this.closeDialog();
          } else {
            this.$log(data.error_msg);
          }
        } catch (error) {
          this.$log(error.error_msg || error);
        }
      },
      getPoint() {
        //   3D - 2D 坐标映射并存储到数组中
        this.scenePoint.forEach((element) => {
          const vector2D = element.cube.position.clone().project(this.camera);
          vector2D.x = this.CANVAS_WIDTH * vector2D.x / 2 + this.CANVAS_WIDTH / 2;
          vector2D.y = -this.CANVAS_HEIGHT * vector2D.y / 2 + this.CANVAS_HEIGHT / 2;
          const point2D = {
            id: element.id,
            position: vector2D
          };
          const arcPosX = point2D.position.x; // 20,20 是右面布局的起始坐标
          const arcPosY = point2D.position.y - document.getElementById('actions').offsetTop - 20 + 40;
          this.draw2DPoint(arcPosX, arcPosY, 1);
          this.renderThisFrame = true;
          // this.pointUVList.push([arcPosX / 1000, arcPosY / 1000]);
          this.pointUVList.push({
            x2d: arcPosX / this.CANVAS_WIDTH,
            y2d: arcPosY / this.CANVAS_HEIGHT,
            p3x: element.cube.position.x,
            p3y: element.cube.position.y,
            p3z: element.cube.position.z
          });
        });
        const d2x = Math.pow((this.pointUVList[0].x2d * this.CANVAS_WIDTH - this.pointUVList[1].x2d * this.CANVAS_WIDTH), 2);
        const d2y = Math.pow((this.pointUVList[0].y2d * this.CANVAS_HEIGHT - this.pointUVList[1].y2d * this.CANVAS_HEIGHT), 2);
        const d2d = Math.sqrt(d2x + d2y);
        const d3x = Math.pow((this.pointUVList[0].p3x - this.pointUVList[1].p3x), 2);
        const d3y = Math.pow((this.pointUVList[0].p3z - this.pointUVList[1].p3z), 2);
        const d3d = Math.sqrt(d3x + d3y);
        this.centerX = this.pointUVList[0].y2d;
        this.scale = d2d / d3d;
        console.log('zero:', this.pointUVList[0].x2d, this.pointUVList[0].y2d);
        console.log('d2d:', d2d, 'd3d:', d3d, 'scale:', d2d / d3d);
        console.log('angle:', this.mcontrols.getRotate());
        console.log('image:', this.getCurrentShot());
        // this.savePointUV();
      },
      draw2DPoint(posX, posY, radius) {
        // 绘制对齐后2D坐标点，方便查看
        this.context.beginPath();
        //  this.context.fillText(id, posX, posY);
        this.context.arc(posX,
          posY,
          radius, 0, 2 * Math.PI, true);
        this.context.closePath();
        this.context.stroke();
        this.context.fill();
      },
      // async saveModelImage() {
      //   const randomNumber = this.randomWord(false, 32);
      //   try {
      //     const {data} = await await this.$http.post(
      //       'http://192.168.80.23:8098/upload/map/' + randomNumber + '.jpg',
      //       this.shotImageUrl.substr(this.shotImageUrl.indexOf(',') + 1, this.shotImageUrl.length),
      //       {headers: {"Content-Type": "text/plain"}}
      //     );
      //     if (data.retcode === 0) {
      //       this.$message.basic({
      //         message: '对齐参数已保存'
      //       });
      //     } else {
      //       this.$log(data.error_msg);
      //     }
      //   } catch (error) {
      //     this.$log(error.error_msg || error);
      //   }
      // },
      // async saveCADImage() {
      //   const randomNumber = this.randomWord(false, 32);
      //   try {
      //     const {data} = await await this.$http.post(
      //       'http://192.168.80.23:8098/upload/map/' + randomNumber + '.jpg',
      //       this.cadImageUrl.substr(this.cadImageUrl.indexOf(',') + 1, this.cadImageUrl.length),
      //       {headers: {"Content-Type": "text/plain"}}
      //     )
      //     if (data.retcode === 0 && data1.retcode === 0) {
      //       this.$message.basic({
      //         message: '对齐参数已保存'
      //       });
      //     } else {
      //       this.$log(data.error_msg);
      //     }
      //   } catch (error) {
      //     this.$log(error.error_msg || error);
      //   }
      // },
      saveCADImage() {
        const randomNumber = this.randomWord(false, 32);
        
        return new Promise((resolve, reject) => {
          this.$http.post(
            '/upload/map/' + randomNumber + '.jpg',
            this.cadImageUrl.substr(this.cadImageUrl.indexOf(',') + 1, this.cadImageUrl.length),
            {headers: {"Content-Type": "text/plain"}}
          ).then(response => {
            // console.log(response.data)
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      saveModelImage() {
        const randomNumber = this.randomWord(false, 32);
        return new Promise((resolve, reject) => {
          this.$http.post(
            '/upload/map/' + randomNumber + '.jpg',
            this.shotImageUrl.substr(this.shotImageUrl.indexOf(',') + 1, this.shotImageUrl.length),
            {headers: {"Content-Type": "text/plain"}}
          ).then(response => {
            // console.log(response.data)
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      async saveAlignMent(floorModel, floorCad) {
        this.getPoint();
        const params = {
          store_id: this.$route.params.modelId,
          floor_name: this.storeName,
          floor_model: floorModel,
          floor_cad: floorCad,
          align_width: 1000,
          align_height: 1000,
          center_x: this.pointUVList[0].x2d,
          center_y: this.pointUVList[0].y2d,
          scale: this.scale,
          theta: this.mcontrols.getRotate()
        }

        console.log(params)
        try {
          const {data} = await await this.$http.post(
            'http://192.168.80.23:8098/navigation/create',
            params
          );
          if(data.retcode === 0) {
            this.getCurrentShot(this.CANVAS_WIDTH, this.CANVAS_HEIGHT, true)
            this.cmdCanvas();
          }
        } catch (error) {
          this.$log(error.error_msg);
        }
      },
      async getStoreInfo() {
        try {
          const {data} = await this.$http.post(
            '/admin/get-store-info?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
            {store_id: this.$route.params.modelId}
          );
          console.log(data)
          if(data.error_no === 200) {
            this.storeName = data.data.store_name;
          }
          console.log(data.data.store_name)
          console.log(this.storeName)
        } catch (error) {
          this.$log(error.error_msg);
        }
      },
      download() {
        Promise.all([this.saveCADImage(), this.saveModelImage()]).then((val) => {
          console.log(val)
          const arr = val.map(o=>o.retcode)
          if(Math.max.apply(null, arr) === Math.min.apply(null, arr)) {
            this.$message.basic({
              message: '对齐参数已保存'
            });
            const arr = val.map((o)=>o.data).map((i)=>i.map((j) => {return j.url}))
            const floorModel = arr[1][0];
            const floorCad = arr[0][0];
            this.saveAlignMent(floorModel, floorCad)
          } else {
            this.$log(data.error_msg);
          }
        }).catch((error) => {
          console.log(error)
        })

        // this.getCurrentShot(this.CANVAS_WIDTH, this.CANVAS_HEIGHT, true)
        // this.cmdCanvas();
      },
      cmdCanvas() {
        let drawImageWidth, drawImageHeight, spaceWidth, spaceHeight, flag = true;
        const canvas = document.createElement("canvas");
        canvas.width = 1000;
        canvas.height = 1000;
        if (this.cadWidth > 1000) {
          drawImageWidth = 1000;
          drawImageHeight = this.cadHeight * 1000 / this.cadWidth;
          spaceWidth = 0;
          spaceHeight = (1000 - drawImageHeight) / 2;
          flag = false;
        }
        if (flag && this.cadHeight > 1000) {
          drawImageWidth = this.cadWidth * 1000 / this.cadHeight;
          drawImageHeight = 1000;
          spaceWidth = (1000 - drawImageWidth) / 2;
          spaceHeight = 0;
        }
        const ctx = canvas.getContext("2d");
        const img = document.getElementsByClassName('upload__image')[0];
        ctx.drawImage(img, spaceWidth, spaceHeight, drawImageWidth, drawImageHeight);
        this.cadImageUrl = canvas.toDataURL("image/jpeg");
        this.downloadIamge(this.cadImageUrl)
      },
      deleteHandle() {
        this.imagePreviewing = null;
        this.uploadSuccee = false;
      },
      sliderHandle(value) {
        this.$refs.uploadImage.style.opacity = value / 100;
      },
      randomWord(randomFlag, min, max) {
        let str = '',
          range = min,
          arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
        // 随机产生
        if (randomFlag) {
          range = Math.round(Math.random() * (max - min)) + min;
        }
        for (let i = 0; i < range; i++) {
          let pos = Math.round(Math.random() * (arr.length - 1));
          str += arr[pos];
        }
        return str;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .editor-panel-markers {
    display: flex;

    &__marker {
      height: 28px;
      width: 28px;
      border-radius: 2px;
      background-color: #d8d8d8;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;
      cursor: pointer;

      &--add {
        background-color: transparent;
        border: 1px solid #999;
        height: 26px;
        width: 26px;
      }

      img {
        width: 16px;
        height: 16px;
        object-fit: contain;
      }

      &--selected {
        border: 2px solid #a9a9a9;
        height: 24px;
        width: 24px;
      }
    }

    &__uploader {
      visibility: hidden;
      position: absolute;
      height: 0;
      width: 0;
      display: inline-block;
    }
  }

  .upload__input {
    visibility: hidden;
  }

  .upload__image {
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    padding: 2px;
    object-fit: contain;
    opacity: 0.8;
  }

  .editor-panel-list {
    height: 350px;
    border-radius: 4px;
    border: 1px solid #d8d8d8;
    display: flex;
    flex-direction: column;

    &__title {
      display: grid;
      background-color: #e5e5e5;
      grid-template-columns: 50% 50%;
      justify-items: center;
      align-items: center;
      height: 26px;
      font-size: 12px;
      color: #666;
      user-select: none;
    }

    &__items {
      overflow-y: scroll;
      flex: 1;
    }

    &__item {
      display: grid;
      background-color: #fff;
      grid-template-columns: 50% 50%;
      justify-items: center;
      align-items: center;
      height: 26px;
      font-size: 12px;
      border-bottom: 1px solid #e5e5e5;

      span {
        color: #666;
      }

      &:last-child {
        border-bottom: 0;
      }
    }

    &__actions .ai-button {
      margin: 0 6px;
    }
  }

  .label-dialog {
    &__header {
      height: 50px;
      display: flex;
      align-items: center;
      margin-left: 20px;
      font-weight: 500;
      color: #6c6c6c;
    }

    &__content {
      display: flex;
      padding: 20px 16px;
    }

    &__footer {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      flex-direction: row-reverse;

      .ai-button {
        width: 59px;
        height: 26px;
        margin: 0 10px;
        font-size: 14px;
      }
    }
  }

  .form {
    display: inline-block;
  }

  .form-item {
    margin-bottom: 20px;
    width: 100%;
    display: flex;

    &:last-child {
      margin-bottom: 0;
    }

    &__label {
      display: inline-flex;
      width: 70px;
      color: #6c6c6c;
      font-size: 14px;
      height: 28px;
      align-items: center;
      flex-direction: row-reverse;
      user-select: none;
    }

    &__content {
      display: inline-block;
      margin-left: 12px;

      .ai-input-wrapper {
        width: 327px;
        height: 28px;
      }

      textarea {
        width: 327px;
        height: 80px;
        font-size: 12px;
      }
    }
  }

  .item-select {
    width: 295px;
    height: 144px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .2);
    border-radius: 4px;
    padding: 16px;
    overflow-y: scroll;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;

    &__item {
      width: 58px;
      height: 58px;
    }
  }

  .preview {
    flex: 1;
    display: flex;
    justify-content: center;
    margin: 0 10px;
    padding: 20px 0;
    border: 1px solid #ffffff;
    background-color: #ffffff;
  }

  .item-info {
    min-width: 272px;
    min-height: 288px;
    text-align: right;
    color: #fff;
    filter: drop-shadow(0 2px 2px #000);
    user-select: none;
    pointer-events: none;

    &__title {
      font-size: 26px;
      line-height: 40px;
      border-bottom: 2px solid #fff;
    }

    &__text {
      font-size: 14px;
      line-height: 20px;
      margin-top: 8px;
    }
  }

  #canvas {
    position: absolute;
    left: 1px;
    top: 1px;
    z-index: 80;
  }

  #drawboard {
    pointer-events: none;
    width: 1000px;
    height: 1000px;
    position: absolute;
    top: 0px;
    z-index: 80;
  }

  #cadimagedivBG {
    width: 1000px;
    height:1000px;
    background: black;
    opacity: 0;
    position: absolute;
    top: 0px;
    pointer-events: none;
    z-index: 1;
  }

  #cadimagediv {
    width: 1000px;
    height: 1000px;
    position: absolute;
    top: 0px;
    border: 1px solid #000;
    pointer-events: none;
    z-index: 1;
  }

  #buttondiv {
    width: 1000px;
    height: 100px;
    position: absolute;
    top: 750px;
    pointer-events: all;
  }

  #buttonR {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  #buttonDL {
    position: absolute;
    bottom: 5px;
    right: 5px;
  }

  #buttonDR {
    position: absolute;
    bottom: 5px;
  }


  #buttonL {
    position: absolute;
    top: 5px;
  }


  #actions {
    width: 1000px;
    height: 1000px;
    position: absolute;
    top: 20px;
    left: 320px;
    border-radius: 2px;
    z-index: 101;
    pointer-events: none;
  }

  #canvas3d {
    width: 1000px;
    height: 1000px;
    background-color: rgb(255, 255, 255); /* or transparent; */
    border: 1px solid black; /* or none; */
    position: absolute;
    left: 320px;
    top: 20px;
    z-index: 100;
  }

  .mng-model-scene-cad {
    width: 100vw;
    height: 100vh;
    background-color: rgb(30, 30, 30);
    flex-direction: column;
    justify-content: center;
    position: relative;
  }

  .handle-left {
    width: 300px;
    height: 100%;
    background-color: #393939;

    h4 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      font-weight: normal;
      border-bottom: 1px solid #101010;
      font-size: 14px;
      color: #ADADAD;
      margin: 0;
      padding-left: 14.3px;
      padding-right: 10px;

      span {
        width: 42px;
        height: 20px;
        border: 1px solid #CCCCCC;
        border-radius: 4px;
        color: #CCCCCC;
        position: relative;
        padding: 0 8px 0 10px;
        line-height: 20px;
        display: inline-block;
        margin-left: 11px;
      }

      h5 {
        font-weight: normal;
        font-size: 16px;
        color: #fff;

        img {
          vertical-align: top;
        }
      }

      .triangle {
        width: 0;
        height: 0;
        position: absolute;
        top: 7px;
        right: 7px;
        border-width: 4px;
        border-style: solid;
        border-color: #ADADAD transparent transparent transparent;
      }

      .slider-wrapper {
        width: 110px;
        height: 25px;
        padding: 0 10px;
        position: absolute;
        top: 23px;
        left: -60px;
        background: #424242;
        box-shadow: 0 1px 4px 2px rgba(0, 0, 0, 0.20);
        border-radius: 4px;
        z-index: 1000;
        /deep/.el-tooltip {
          background: url('../../../assets/views/models/slider.png') no-repeat;
          width: 12px;
          height: 12px;
          border: none;
        }
        /deep/.el-slider__runway{
          height: 2px;
          background-color: rgb(140, 140, 140);
        }
        /deep/.el-slider__bar{
          height: 2px;
          background-color: rgb(140, 140, 140);
        }
        /deep/.el-slider__button-wrapper{
          top: -18px
        }
      }
    }

    .look-down {
      justify-content: normal;
    }

    .original {
      border-bottom: 1px solid #101010;
      position: relative;

      .original-center {
        width: 150px;
        height: 150px;
        margin: 24px 75px;
        border: 2px dashed #ADADAD;
      }

      .upload-button {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        cursor: pointer;

        .icon-add {
          width: 24.5px;
          height: 24.5px;
        }
      }

      .delete-cad {
        width: 24px;
        height: 24px;
        position: absolute;
        bottom: 25px;
        right: 38px;
      }
    }

    .save-button-disabled {
      width: 200px;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      font-size: 16px;
      text-align: center;
      margin-left: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
      margin-bottom: 20px;
      border: 1px solid #ADADAD;
      color: #ADADAD;
      pointer-events: none;
    }

    .save-button-succee {
      width: 200px;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      font-size: 16px;
      text-align: center;
      margin-left: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
      margin-bottom: 20px;
      color: #08CE82;
      border: 1px solid #08CE82;
    }
  }

  .box {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    z-index: 999;
  }


</style>
